import { render } from "./PortalSearch.vue?vue&type=template&id=2db28390&scoped=true&ts=true"
import script from "./PortalSearch.vue?vue&type=script&lang=ts"
export * from "./PortalSearch.vue?vue&type=script&lang=ts"

import "./PortalSearch.vue?vue&type=style&index=0&id=2db28390&scoped=true&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db28390"]])

export default __exports__